import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {FolderOpenIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, PropsWithChildren} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

export const CallToActionNotice: FunctionComponent<{
  title: string;
  subtitle: string;
  link?: {to: string; text: string};
  className?: string;
}> = ({title, subtitle, link: propsLink, className = ''}) => {
  const {t} = useTranslation('translation');

  const link = propsLink ?? {to: ExchangeRoute.HOME, text: t('components.callToActionNotice.defaultCtaText')};

  return (
    <div className={`h-full flex flex-col justify-center items-center text-white ${className}`}>
      <FolderOpenIcon className='w-7 h-7 stroke-white fill-transparent mb-4' />
      <span className='text-xl md:text-2xl font-semibold mb-1 uppercase'>{title}</span>
      <span className='text-gray-500 font-light mb-2'>{subtitle}</span>
      <Link to={link.to} className='text-sm md:text-base font-bold bg-deepblue px-4 py-2 mt-6 rounded-full uppercase'>
        {link.text}
      </Link>
    </div>
  );
};

export const EmptyMessage: FunctionComponent<PropsWithChildren<{}>> = ({children}) => (
  <div className='text-xl text-white md:text-2xl font-semibold'>{children}</div>
);
